import { memo } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  FormHelperText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import dayjs from "dayjs";

interface ExamRequest {
  id: string;
  description: string;
  date: string;
  category: string;
  practitioner: string;
  specialty?: string;
}

interface ExamRequestSelectProps {
  examRequests: ExamRequest[];
  selectedRequestId: string | null;
  onSelectRequest: (requestId: string | null) => void;
  noLinking: boolean;
  onNoLinkingChange: (checked: boolean) => void;
}

export const ExamRequestSelect = memo(
  ({
    examRequests,
    selectedRequestId,
    onSelectRequest,
    noLinking,
    onNoLinkingChange,
  }: ExamRequestSelectProps) => {
    // Filtrando apenas por descrição válida
    const validExams = examRequests.filter(
      (request) => request.description && request.description !== "-"
    );

    return (
      <Stack spacing={1}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="exam-request-select-label">
            Solicitação de exame
          </InputLabel>
          <Select
            labelId="exam-request-select-label"
            value={selectedRequestId || ""}
            onChange={(e) => onSelectRequest(e.target.value || null)}
            disabled={noLinking}
          >
            <MenuItem value="">
              <em>Nenhuma solicitação selecionada</em>
            </MenuItem>
            {validExams.map((request) => (
              <MenuItem key={request.id} value={request.id}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body2">{request.description}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {request.date || "-"}
                  </Typography>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* <FormControlLabel
          control={
            <Checkbox
              checked={noLinking}
              onChange={(e) => {
                onNoLinkingChange(e.target.checked);
                if (e.target.checked) {
                  onSelectRequest(null);
                }
              }}
            />
          }
          label="Não desejo vincular a uma solicitação"
        /> */}
      </Stack>
    );
  }
);
